import Map from './Map.vue';
import Notification from './Notification.vue';

export default Map;

export {
    Map,
    Notification
};


// WEBPACK FOOTER //
// ./src/components/page/map/index.ts